import { useState, useEffect } from 'react';

var useHashParams = function useHashParams() {
  var _a = useState(new URLSearchParams(typeof window !== 'undefined' ? window.location.hash.slice(1) : '')),
    params = _a[0],
    setParams = _a[1];
  useEffect(function () {
    if (typeof window === 'undefined') return;
    var handleHashChange = function handleHashChange() {
      setParams(new URLSearchParams(window.location.hash.slice(1)));
    };
    window.addEventListener('hashchange', handleHashChange);
    return function () {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);
  return params;
};

export { useHashParams as default };
//# sourceMappingURL=index.js.map
